<template>
  <div class="login-page">
    <div>
      <div class="form">
        <div class="form__image">
          <img class="logo" src="../../../assets/images/hrdesk-logo-dark-beta.png" />
        </div>
        <div class="form__token">
          Please enter the password sent to your email. If you don’t see it in
          your inbox, please check your junk folder/spam.
        </div>

        <form @submit.prevent="changePassword">
          <div class="login-form">
            <div class="login-form--email">Password</div>
            <div class="login-form--input">
              <input type="password" v-model="password" placeholder="Enter password" />
            </div>
          </div>

          <div class="login-form">
            <div class="login-form--email">New Password</div>
            <div class="login-form--input">
              <input type="password" v-model="newPassword" placeholder="Enter your new password" />
            </div>
          </div>

          <div class="login-form">
            <div class="login-form--email">Confirm New Password</div>
            <div class="login-form--input">
              <input type="password" v-model="confirmNewPassword" placeholder="Confirm your new password" />
            </div>
          </div>
          <div v-show="startValidation" class="login-error">
            <div v-if="isPasswordEmpty">Password is required.</div>
            <div v-if="!isPasswordStrong">
              Password must be at least 8 characters long and contain at least
              one lowercase letter, one uppercase letter, one number, and one
              special character.
            </div>
            <div v-if="!isConfirmedPassword">Passwords do not match.</div>
            <div v-if="errorMsg">
              Wrong Password. Please check your input and try again.
            </div>
            <div class="message" v-show="successMsg">
              Wrong Password. Please check your input and try again.
            </div>
            <span v-show="networkError">An error occured. Please try again.</span>
          </div>

          <div class="login-btn">
            <button type="submit" :disabled="load">
              <div v-if="load">
                <WhiteLoader />
              </div>
              <span v-else>Reset Password</span>
            </button>
          </div>
        </form>
      </div>

      <div class="footer-message">
        <p class="footer-message--copyright">© 2024 hrdesk</p>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import WhiteLoader from "../../partials/white-loader";

export default {
  components: {
    WhiteLoader,
  },
  data() {
    return {
      startValidation: false,
      password: "",
      newPassword: "",
      confirmNewPassword: "",
      load: false,
      errorMsg: false,
      successMsg: false,
      networkError: false,
    };
  },
  methods: {
    changePassword() {

      this.startValidation = true;

      if (
        this.isPasswordEmpty ||
        !this.isPasswordStrong ||
        !this.isConfirmedPassword
      ) {
        return;
      }
      this.load = true;

      this.$http
        .post(types.UPDATE_PASSWORD_API, {
          current_password: this.password,
          new_password: this.newPassword,
          password_confirm: this.confirmNewPassword,
        })
        .then((resp) => {
          if (this.$store.getters.userIsAdmin) {
            return this.$router.push("/dashboard");
          }

          if (this.$store.getters.userIsUser) {
            return this.$router.push("/employee-portal");
          }

          if (this.$store.getters.userIsJobseeker) {
            return this.$router.push("/jobseeker-profile");
          }

          this.successMsg = true;

          this.password = "";
          this.newPassword = "";
          this.confirmNewPassword = "";
          this.load = false;
        })
        .catch((err) => {
          this.load = false;
          if (err.response.status === 422) {
            this.errorMsg = true;
          } else {
            this.networkError = true;
          }
        });
    },
  },

  computed: {
    isPasswordEmpty() {
      return this.startValidation ? this.password === "" : false;
    },
    isPasswordStrong() {
      return this.startValidation
        ? /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/.test(
          this.newPassword
        )
        : false;
    },
    isConfirmedPassword() {
      return this.startValidation
        ? this.newPassword === this.confirmNewPassword
        : false;
    },
  },
};
</script>


<style scoped>
.login-page {
  background: #fbfafa;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.remember-me {
  display: block;
  width: 50px;
  float: left;
}

.icon-space {
  margin: 1px;
}

.login-page>div {
  max-width: 600px;
  margin: 50px auto;
  padding: 0 10px;
}

.form {
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 7.552vw;
  padding-right: 7.552vw;
}

.form__image {
  margin: auto;
  max-width: 183px;
}

.form__token {
  margin-top: 20px;
}

.login-form {
  margin-top: 20px;
  overflow: hidden;
}

.login-form--email {
  width: 100%;
  float: left;
  text-align: left;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}

.login-form--password {
  width: 40%;
  float: left;
  text-align: left;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}

.login-form--input {
  max-width: 523px;
  margin: auto;
  height: 40px;
  border: solid 1px #c7c7c7;
  clear: both;
  overflow: hidden;
}

.login-form--input>input {
  height: 40px;
  border: none;
  outline: none;
  padding: 0 5px;
  font-size: 14px;
  font-weight: 200;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.5;
  letter-spacing: normal;
  text-align: left;
  color: #000;
}

.login-form--input>input::placeholder {
  background: transparent;
  opacity: 0.32;
}

.login-form--input>input::-ms-input-placeholder {
  background: transparent;
  opacity: 0.32;
}

.login-form--input>input::-ms-input-placeholder {
  background: transparent;
  opacity: 0.32;
}

.login-error {
  margin-top: 10px;
  color: red;
  font-size: 12px;
  font-style: italic;
}

.login-error>p {
  margin: 0;
}

.login-error>span>a {
  text-decoration: underline;
  font-weight: 600;
}

.login-btn {
  margin-top: 10px;
  margin-bottom: 26px;
}

.login-btn>button {
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #5099de;
  height: 40px;
  border: none;
  outline: none;
  color: #fff;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.login-btn>div {
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #5099de;
  height: 40px;
  border: none;
  outline: none;
  color: #fff;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
}

.login-checkbox {
  text-align: left;
  overflow: hidden;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  align-content: flex-start;
}

.login-checkbox-box {
  width: 20px;
  height: 20px;
  float: left;
  text-align: left;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  align-content: center;
}

.login-checkbox-text {
  width: 300px;
  height: 20px;
  float: left;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  text-align: left;
  color: #000000;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  align-content: center;
}

.line-through {
  margin-top: 20px;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #c7c7c7;
  line-height: 0.1em;
  margin: 10px 0 20px;
  color: grey;
}

.line-through span {
  background: #fff;
  padding: 0 10px;
  color: #c7c7c7;
}

.form__google {
  height: 40px;
  border-radius: 2px;
  margin-top: 26px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
  border: solid 1px #c7c7c7;
  cursor: pointer;
}

.form__google>div {
  width: 95px;
  margin: auto;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
}

.form__google--image {
  width: 28px;
  float: left;
}

.form__google--name {
  float: right;
  padding-top: 0.26vw;
  width: 60px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: center;
  color: #5099de;
}

.message {
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #5099de;
  padding-bottom: 5px;
}

.message>a {
  color: #bababc;
}

.footer-message {
  text-align: center;
  margin-top: 29px;
}

.footer-message--register {
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #777777;
}

.footer-message--register>a {
  color: #5099de;
  text-decoration: none;
}

.footer-message--company {
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #5099de;
}

.footer-message--company>a {
  color: #5099de;
  text-decoration: none;
}

.footer-message--copyright {
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}
</style>